'use strict';
export function Pager(type, id, model) {
  Object.defineProperties(this, {
    "type": {
      get: function() {return this._type;},
      set: function(value) {
        if(!value) {
          throw new TypeError('typeプロパティ値が指定されていません。');
        }
        this._type = value;
      },
      enumerable: true
    },
    "id": {
      get: function() {return this._id;},
      set: function(value) {
        if(!value) {
          throw new TypeError('idプロパティ値が指定されていません。');
        }
        this._id = value;
      },
      enumerable: true
    },
    "currentPage": {
      get: function() {return this._currentPage;},
      set: function(value) {
        if(!value) {
          throw new TypeError('currentPageプロパティ値が指定されていません。');
        }
        this._currentPage = parseInt(value, 10);
      },
      enumerable: true
    },
    "lastPage": {
      get: function() {return this._lastPage;},
      set: function(value) {
        if(!value) {
          throw new TypeError('lastPageプロパティ値が指定されていません。');
        }
        this._lastPage = parseInt(value, 10);
      },
      enumerable: true
    }
  });
  this.type = type;
  if(id) {
    this.id = id;
  }
  this.currentPage = model.current;
  this.lastPage = model.last;
};
Pager.prototype.create = function() {
  var df = document.createDocumentFragment();
  var container = document.createElement('div');
  container.className = 'container--pagination';
  df.appendChild(container);

  var pagination = document.createElement('ul');
  pagination.id = 'pagination';
  pagination.className = 'pagination';
  df.firstChild.appendChild(pagination);

  if(this.currentPage !== 1) {
    var previousItem = document.createElement('li');
    previousItem.className = 'previous';
    var previousAnchor = document.createElement('a');
    previousAnchor.href = '?type=' + this.type;
    if(this.id) {
      previousAnchor.href += '&id=' + this.id;
    }
    if(this.currentPage - 1 !== 1) {
      previousAnchor.href += '&p=' + (this.currentPage - 1);
    }
    previousAnchor.textContent = '前へ';
    previousItem.appendChild(previousAnchor);
    df.querySelector('#pagination').appendChild(previousItem);
  }

  var CURRENT_OFFSET_PAGE = this.currentPage - Math.ceil(9 / 2);
  if(CURRENT_OFFSET_PAGE < 0) {
    CURRENT_OFFSET_PAGE = 0;
  }
  var MAX_PAGE = CURRENT_OFFSET_PAGE + 9;
  if(MAX_PAGE > this.lastPage) {
    MAX_PAGE = this.lastPage;
  }
  for(var i = CURRENT_OFFSET_PAGE; i < MAX_PAGE; i++) {
    df.querySelector('#pagination').appendChild(this.createPageIndex(i));
  }

  if(this.currentPage !== this.lastPage) {
    var nextItem = document.createElement('li');
    nextItem.className = 'next';
    var nextItemAnchor = document.createElement('a');
    nextItemAnchor.href = '?type=' + this.type;
    if(this.id) {
      nextItemAnchor.href += '&id=' + this.id;
    }
    nextItemAnchor.href += '&p=' + (this.currentPage + 1);
    nextItemAnchor.textContent = '次へ';
    nextItem.appendChild(nextItemAnchor);
    df.querySelector('#pagination').appendChild(nextItem);
  }
  return df;
};
Pager.prototype.createPageIndex = function(pageIndex) {
  var listitem = document.createElement('li');
  if(pageIndex + 1 === this.currentPage) {
    listitem.className = 'active';
    listitem.textContent = pageIndex + 1;
  } else {
    var anchor = document.createElement('a');
    anchor.href = '?type=' + this.type;
    if(this.id) {
      anchor.href += '&id=' + this.id;
    }
    if(pageIndex + 1 !== 1) {
      anchor.href += '&p=' + (pageIndex + 1);
    }
    anchor.textContent = pageIndex + 1;
    listitem.appendChild(anchor);
  }
  return listitem;
};